// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"867":"3b551c213f363658","2947":"4d181e1bce10ada4","3578":"425efebfc692f61f","3874":"572d695ca6777461"}[chunkId] + ".css";
};